
import React from 'react';
import { Globe, Megaphone, Calendar, Users, CheckCircle } from 'lucide-react';

const CanauxSection = () => {
  const canaux = [
    {
      icon: Globe,
      title: "Digital",
      description: "Réseaux sociaux, site web, emailing, publicité en ligne",
      features: ["Social Media", "SEO/SEM", "Content Marketing", "Influence Marketing"]
    },
    {
      icon: Megaphone,
      title: "Relations Presse",
      description: "Médias traditionnels, communiqués, relations journalistes",
      features: ["Communiqués de presse", "Relations médias", "Dossiers de presse", "Interviews"]
    },
    {
      icon: Calendar,
      title: "Événementiel",
      description: "Événements physiques et digitaux, salons, conférences",
      features: ["Événements corporate", "Webinaires", "Salons professionnels", "Team building"]
    },
    {
      icon: Users,
      title: "Communication Interne",
      description: "Newsletters internes, intranet, communication RH",
      features: ["Newsletter interne", "Intranet", "Communication managériale", "Formation"]
    }
  ];

  return (
    <section className="py-20 bg-navy-50/30">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-navy-900 mb-6">
              Mes <span className="font-semibold text-blue-600">canaux</span> d'expertise
            </h2>
            <p className="text-lg text-navy-600 font-light max-w-2xl mx-auto">
              Une maîtrise complète de l'écosystème communicationnel moderne
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {canaux.map((canal, index) => (
              <div key={index} className="bg-white p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <canal.icon className="text-blue-600 mb-4" size={32} />
                <h3 className="text-xl font-semibold text-navy-900 mb-4">{canal.title}</h3>
                <p className="text-navy-600 font-light mb-6 text-sm">{canal.description}</p>
                <ul className="space-y-2">
                  {canal.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2 text-xs text-navy-600">
                      <CheckCircle size={10} className="text-blue-600 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CanauxSection;
